import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import Plugin from '@jbrowse/core/Plugin';
import BamAdapterF from './CramAdapter';
import CramAdapterF from './BamAdapter';
import HtsgetBamAdapterF from './HtsgetBamAdapter';
import SNPCoverageAdapterF from './SNPCoverageAdapter';
import SNPCoverageRendererF from './SNPCoverageRenderer';
import PileupRendererF from './PileupRenderer';
import LinearAlignmentsDisplayF from './LinearAlignmentsDisplay';
import LinearSNPCoverageDisplayF from './LinearSNPCoverageDisplay';
import LinearReadArcsDisplayF from './LinearReadArcsDisplay';
import LinearReadCloudDisplayF from './LinearReadCloudDisplay';
import AlignmentsTrackF from './AlignmentsTrack';
import AlignmentsFeatureWidgetF from './AlignmentsFeatureDetail';
import PileupRPCMethodsF from './PileupRPC';
import GuessAlignmentsTypesF from './GuessAlignmentsTypes';
import LinearPileupDisplayF, { linearPileupDisplayStateModelFactory, linearPileupDisplayConfigSchemaFactory } from './LinearPileupDisplay';
import * as MismatchParser from './MismatchParser';
var AlignmentsPlugin = /*#__PURE__*/function (_Plugin) {
  _inherits(AlignmentsPlugin, _Plugin);
  function AlignmentsPlugin() {
    var _this;
    _classCallCheck(this, AlignmentsPlugin);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(AlignmentsPlugin).apply(this, arguments));
    _this.name = 'AlignmentsPlugin';
    return _this;
  }
  _createClass(AlignmentsPlugin, [{
    key: "install",
    value: function install(pluginManager) {
      ;
      [CramAdapterF, BamAdapterF, LinearPileupDisplayF, LinearSNPCoverageDisplayF, AlignmentsTrackF, SNPCoverageAdapterF, HtsgetBamAdapterF, PileupRendererF, PileupRPCMethodsF, SNPCoverageRendererF, LinearReadArcsDisplayF, LinearReadCloudDisplayF, LinearAlignmentsDisplayF, AlignmentsFeatureWidgetF, GuessAlignmentsTypesF].map(function (f) {
        return f(pluginManager);
      });
    }
  }]);
  return AlignmentsPlugin;
}(Plugin);
export { AlignmentsPlugin as default };
export { linearPileupDisplayConfigSchemaFactory, linearPileupDisplayStateModelFactory, MismatchParser };